import React, { useState } from 'react'
import Namespace from 'src/constants/locale/Namespace'
import TermsAndConditionsKeys from 'src/constants/locale/key/TermsAndConditions'
import { Grid, Card, Typography } from '@material-ui/core'
import {
  components,
  DataFlattener,
  DateTimeFormatter,
} from 'cng-web-lib'
import makeValidationSchema from './MakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import { useFormContext } from 'react-hook-form'
import _ from 'lodash'
import CngSection from '../../components/cngcomponents/CngSection'

const {
  form: {
    field: {
      CngTextField,
      CngDateField,
      CngSwitchField
    },
  },
  CngGridItem
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  id: "",
  content: "",
  active: true,
  versionNumber: "",
  createdBy: "",
  createdDate: "",
  updatedBy: "",
  updatedDate: "",
  version: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({ disabled, isView, isEdit, showNotification, shouldHideMap }) {
  const { translate } = useTranslation(Namespace.ANNOUNCEMENT)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let title = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.TITLE
    )
    let id = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.ID
    )
    let content = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.CONTENT
    )
    let versionNumber = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.VERSION_NUMBER
    )
    let createdBy = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.CREATED_BY
    )
    let createdDate = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.CREATED_DATE
    )
    let active = translate(
      Namespace.TERMS_AND_CONDITIONS,
      TermsAndConditionsKeys.ACTIVE
    )    

    return {
      title,
      id,
      content,
      versionNumber,
      createdBy,
      createdDate,
      active,
    }
  }

	return (
    <>
      <CngSection title={translatedTextsObject.title}>
        <Grid container spacing={3}>
          { isEdit && 
            <Grid item xs={12}>
              <Typography color="info" variant="subtitle2">
                Content and version number are non-editable, only active status can be updated.
              </Typography>
            </Grid>
          }
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <CngGridItem xs={12} shouldHide={shouldHideMap.content}>
                <CngTextField
                  name="content"
                  label={translatedTextsObject.content}
                  disabled={disabled}
                  isRequired
                  multiline
                  rows={10}
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.versionNumber}>
                <CngTextField
                  name="versionNumber"
                  label={translatedTextsObject.versionNumber}
                  isRequired
                  disabled={disabled}
                />
              </CngGridItem>
              <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap.active}>
                <CngSwitchField
                  name="active"
                  label={translatedTextsObject.active}
                />    
              </CngGridItem>
            </Grid>
          </Grid>
        </Grid>
      </CngSection>
    </>
	)
}

function toClientDataFormat(serverData) {
  let localData = { ...serverData }

  localData.startDate = DateTimeFormatter.toClientDate(
    localData.startDate
  );
  localData.endDate = DateTimeFormatter.toClientDate(
    localData.endDate
  );
  localData.createdDate = DateTimeFormatter.toClientDate(
    localData.createdDate
  );
  localData.updatedDate = DateTimeFormatter.toClientDate(
    localData.updatedDate
  );
  return localData;
}

function toServerDataFormat(localData) {
  localData.startDate = DateTimeFormatter.toServerDate(
    localData.startDate
  );
  localData.endDate = DateTimeFormatter.toServerDate(
    localData.endDate
  );
  localData.createdDate = DateTimeFormatter.toServerDate(
    localData.createdDate
  );
  localData.updatedDate = DateTimeFormatter.toServerDate(
    localData.updatedDate
  );
  return DataFlattener.unflatten(localData);
}

const FormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields,
  toClientDataFormat: toClientDataFormat,
  toServerDataFormat: toServerDataFormat
})

export default FormProperties
